export const GET_DATA_REQUEST = "GET_DATA_REQUEST"
export const GET_DATA_SUCSSES = "GET_DATA_SUCSSES"
export const GET_DATA_FAILUER = "GET_DATA_FAILUER"